import * as Constants from '@internal/constants';
import { checkVAT, countries } from 'jsvat';

const acreInOneHectare = 0.4046872609874;

export const countryData = {
  US: {
    countryCode: 'US',
    states: [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DE',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
      'DC',
    ],
    postalCodeLabel: 'Zip Code',
    postalCodeLength: 5,
    stateLabel: 'State',
    paymentTypes: {
      dealer: [
        'invoice',
        'srp',
        'grower-deferred',
        'credit',
        'checking',
        'saving',
      ],
      grower: ['credit', 'checking', 'saving'],
    },
    supportedCreditCards: ['visa', 'mastercard', 'amex', 'jcb', 'discover'],
    currencyLabel: 'USD',
    shippingOptions: ['shipping', 'shipping_two', 'shipping_exp'],
  },
  CA: {
    countryCode: 'CA',
    states: [
      'AB',
      'BC',
      'MB',
      'NB',
      'NL',
      'NT',
      'NS',
      'NU',
      'ON',
      'PE',
      'QC',
      'SK',
      'YT',
    ],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 7,
    stateLabel: 'Province/Territory',
    paymentTypes: {
      dealer: ['invoice', 'srp', 'grower-deferred', 'credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'CAD',
    shippingOptions: ['shipping', 'shipping_two'],
  },
  BR: {
    countryCode: 'BR',
    postalCodeLabel: 'Código Postal',
    stateLabel: 'Estado',
    postalCodeLength: 9,
    currencyLabel: 'BRL',
    states: [
      'AC',
      'AL',
      'AM',
      'AP',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MG',
      'MS',
      'MT',
      'PA',
      'PB',
      'PE',
      'PI',
      'PR',
      'RJ',
      'RN',
      'RO',
      'RR',
      'RS',
      'SC',
      'SE',
      'SP',
      'TO',
    ],
    supportedCreditCards: [
      'visa',
      'mastercard',
      'amex',
      'elo',
      'diners',
      'discover',
    ],
    paymentTypes: {
      dealer: ['invoice', 'srp', 'grower-deferred'],
      grower: ['credit', 'boleto'],
    },
    shippingOptions: ['shipping'],
  },
  FR: {
    countryCode: 'FR',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  DE: {
    countryCode: 'DE',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'State',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  UA: {
    countryCode: 'UA',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'UAH',
    shippingOptions: ['shipping'],
  },
  IT: {
    countryCode: 'IT',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'State',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  RO: {
    countryCode: 'RO',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'State',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  ES: {
    countryCode: 'ES',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'State',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  GB: {
    countryCode: 'GB',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  HU: {
    countryCode: 'HU',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  PL: {
    countryCode: 'PL',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  AR: {
    countryCode: 'AR',
    states: [
      'C',
      'B',
      'K',
      'H',
      'U',
      'X',
      'W',
      'E',
      'P',
      'Y',
      'L',
      'F',
      'M',
      'N',
      'Q',
      'R',
      'A',
      'J',
      'D',
      'Z',
      'S',
      'G',
      'V',
      'T',
    ],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'USD',
    shippingOptions: ['shipping'],
  },
  ZA: {
    countryCode: 'ZA',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'State',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'ZAR',
    shippingOptions: ['shipping'],
  },
  GR: {
    countryCode: 'GR',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  PT: {
    countryCode: 'PT',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'EUR',
    shippingOptions: ['shipping'],
  },
  TR: {
    countryCode: 'TR',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'TRY',
    shippingOptions: ['shipping'],
  },
  AU: {
    countryCode: 'AU',
    states: [],
    postalCodeLabel: 'Postal Code',
    postalCodeLength: 5,
    stateLabel: 'Region',
    paymentTypes: {
      dealer: ['credit'],
      grower: ['credit'],
    },
    supportedCreditCards: ['visa', 'mastercard'],
    currencyLabel: 'AUD',
    shippingOptions: ['shipping'],
  },
};

//To avoid confusion, we're really seeing EUROPE_COUNTRIES as EMEA
export const EU_COUNTRIES = [
  'FR',
  'DE',
  'IT',
  'RO',
  'ES',
  'GB',
  'PL',
  'HU',
  'GR',
  'PT',
];
export const NON_EU_COUNTRIES = ['UA'];
export const EUROPE_COUNTRIES = [
  ...EU_COUNTRIES,
  ...NON_EU_COUNTRIES,
  'ZA',
  'TR',
];
export const isEU = countryCode => EU_COUNTRIES.includes(countryCode);
export const isEurope = countryCode => EUROPE_COUNTRIES.includes(countryCode);
export const alwaysTaxedCountries = ['CA'];
export const northAmericanCountries = ['US', 'CA'];
export const isNorthAmerica = countryCode =>
  northAmericanCountries.includes(countryCode);

export const useTerminalStreetNumber = ['BR'];

export const countryVatPrefixMask = '99';

export const nonEUVATSizes = {
  UA: [9, 10, 12],
  ZA: [10],
};

export const countryFiscalData = {
  masks: {
    IT: 'aaaaaa99a99a999a',
  },
};

export const getFiscalMask = country => countryFiscalData.masks[country] || '';

export const taxOfficeBoardMaxLength = 11;

export function isTaxOfficeBoardLengthValid(taxOfficeBoard) {
  const valid =
    taxOfficeBoard.length <= taxOfficeBoardMaxLength &&
    taxOfficeBoard.length > 0;
  return valid;
}

export const allowDownloadInvoice = country =>
  country !== 'BR' && country !== 'UA';

export const allowDownloadDocuments = country =>
  country !== 'AR' && country !== 'ZA';

export const allowInvoiceLinkCheckout = country =>
  !['AR', 'BR'].includes(country);

export const acreToHectare = (acre = 0) =>
  parseFloat(acre * acreInOneHectare).toFixed(0);

export const isBulkOrder = (newHectares, existingHectares, countryCode) => {
  if (existingHectares < 0) {
    existingHectares = 0;
  }
  const totalHectares = newHectares + existingHectares;
  return (
    !!Constants.bulkMessageHectareLimit[countryCode] &&
    totalHectares > Constants.bulkMessageHectareLimit[countryCode]
  );
};

export const SAP_COUNTRIES = ['AR'];

export const isSap = countryCode => SAP_COUNTRIES.includes(countryCode);

const allowedLocale = [
  'en_US',
  'en_BR',
  'en_UA',
  'en_FR',
  'en_DE',
  'en_AU',
  'pt_BR',
  'en_CA',
  'fr_CA',
  'uk_UA',
  'ru_UA',
  'fr_FR',
  'de_DE',
  'en_IT',
  'it_IT',
  'en_RO',
  'ro_RO',
  'en_ES',
  'es_ES',
  'en_PL',
  'pl_PL',
  'en_GB',
  'en_HU',
  'hu_HU',
  'en_AR',
  'es_AR',
  'af_ZA',
  'en_ZA',
  'en_GR',
  'el_GR',
  'en_PT',
  'pt_PT',
  'en_TR',
  'tr_TR',
  'ru_RU',
];

const defaultLocaleMapping = {
  en: 'en_US',
  fr: 'fr_FR',
  pt: 'pt_PT',
  es: 'es_ES',
  de: 'de_DE',
  it: 'it_IT',
  pl: 'pl_PL',
  hu: 'hu_HU',
  ro: 'ro_RO',
  tr: 'tr_TR',
  ru: 'ru_RU',
  uk: 'uk_UA',
  el: 'el_GR',
};

export function isLocaleAllowed(locale) {
  return allowedLocale.includes(locale);
}

export function getNormalizedLocale(locale) {
  if (locale.length === 2) {
    locale = defaultLocaleMapping[locale];
  }
  return locale;
}

export function isFiscalCodeValid(countryCode, fiscalValue) {
  const result = checkVAT(countryCode + fiscalValue, countries);
  // tech debt - PL specific check has to be supported by jsvat, raise a ticket with them
  if (countryCode === 'PL') {
    // tech debt - calculatedNum can be done using array.reduce()
    const caluclatedNum =
      6 * Number(fiscalValue[0]) +
      5 * Number(fiscalValue[1]) +
      7 * Number(fiscalValue[2]) +
      2 * Number(fiscalValue[3]) +
      3 * Number(fiscalValue[4]) +
      4 * Number(fiscalValue[5]) +
      5 * Number(fiscalValue[6]) +
      6 * Number(fiscalValue[7]) +
      7 * Number(fiscalValue[8]);

    const modulo = caluclatedNum % 11;
    const auxFiscalCodeValidity =
      modulo === 10 || Number(fiscalValue) === 0
        ? false
        : modulo === Number(fiscalValue[9]) && result.isValid === true
        ? true
        : false;

    return auxFiscalCodeValidity;
  }

  return result.isValid;
}
